module.exports = __webpack_public_path__ + "img/access-inner-app.b27fe83a.svg";